import { Component } from 'react'
import PropTypes from 'prop-types'

const firstUpperCase = str => str.replace(/^\S/, s => s.toUpperCase())

const createSubComponent = type => Comp => class SubComponent extends Component {
  static displayName = firstUpperCase(type)
  displayName = type
  type = type

  static propTypes = {
    centralizedUpdates: PropTypes.func, // 更新对应的 config, 由 chart render 时传入
    beforeProcess: PropTypes.func,
    processed: PropTypes.func,
    ...Comp.propTypes,
  }

  static defaultProps = {
    ...Comp.defaultProps
  }

  render() {
    return null
  }

  componentDidMount() {
    const { centralizedUpdates } = this.props
    centralizedUpdates && centralizedUpdates(this)
  }

  componentDidUpdate() {
    const { centralizedUpdates } = this.props
    centralizedUpdates && centralizedUpdates(this)
  }
}

@createSubComponent('coord')
export class Coord extends Component {
}

@createSubComponent('axis')
export class Axis extends Component {
  static propTypes = {
    field: PropTypes.string,
    show: PropTypes.bool,
    line: PropTypes.object,
    labelOffset: PropTypes.number,
    grid: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    tickLine: PropTypes.object,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    position: PropTypes.oneOf(['bottom', 'left', 'right']),
  }

  static defaultProps = {
  }
}

@createSubComponent('guide')
export class Guide extends Component {
}

@createSubComponent('series')
export class Geom extends Component {
}

@createSubComponent('tooltip')
export class Tooltip extends Component {
}

@createSubComponent('legend')
export class Legend extends Component {
}

@createSubComponent('pieLabel')
export class PieLabel extends Component {
}
